import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ChevronLeft, Scale, Lock, FileText } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardHeader, CardTitle, CardContent } from './ui/card';
import { LEGAL_CONTENT } from '../lib/LegalContent';

const LegalDetail = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const type = queryParams.get('type') || 'KVKK';

    const content = LEGAL_CONTENT[type];

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [type]);

    if (!content) {
        return (
            <div className="p-8 text-center text-white">
                <p>İçerik bulunamadı.</p>
                <Button onClick={() => navigate(-1)} className="mt-4">Geri Dön</Button>
            </div>
        );
    }

    const getIcon = () => {
        switch (type) {
            case 'KVKK': return <Scale className="w-6 h-6 text-blue-500" />;
            case 'PRIVACY': return <Lock className="w-6 h-6 text-green-500" />;
            case 'TERMS': return <FileText className="w-6 h-6 text-yellow-500" />;
            default: return <Scale className="w-6 h-6" />;
        }
    };

    return (
        <div className="max-w-4xl mx-auto p-4 md:p-8 space-y-6">
            <div className="flex items-center gap-4 mb-6">
                <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => navigate(-1)}
                    className="text-gray-400 hover:text-white"
                >
                    <ChevronLeft className="w-6 h-6" />
                </Button>
                <h1 className="text-2xl font-bold text-white flex items-center gap-2">
                    {getIcon()}
                    Yasal Metinler
                </h1>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
                {Object.keys(LEGAL_CONTENT).map((k) => (
                    <Button
                        key={k}
                        variant={type === k ? "default" : "outline"}
                        onClick={() => navigate(`/legal?type=${k}`)}
                        className={`justify-start ${type === k ? 'bg-blue-600' : 'border-gray-800 text-gray-400'}`}
                    >
                        {k === 'KVKK' ? 'KVKK' : k === 'PRIVACY' ? 'Gizlilik' : 'Kullanım Şartları'}
                    </Button>
                ))}
            </div>

            <Card className="bg-[#1a1a1b] border-gray-800 shadow-xl overflow-hidden animate-in fade-in duration-500">
                <CardHeader className="border-b border-gray-800 bg-[#1d1d1e]">
                    <CardTitle className="text-xl text-white">
                        {content.title}
                    </CardTitle>
                </CardHeader>
                <CardContent className="p-6 md:p-10">
                    <div className="text-gray-300 whitespace-pre-wrap leading-relaxed space-y-4">
                        {content.content}
                    </div>
                </CardContent>
            </Card>

            <div className="text-center pt-8 text-gray-500 text-sm">
                © {new Date().getFullYear()} SNAPP Spor Teknolojileri. Tüm hakları saklıdır.
            </div>
        </div>
    );
};

export default LegalDetail;
